import { useMemo } from 'react';
import { useCustomMask } from '@direct-frontend/components';

export const useUrlMask = () => {
    const urlMaskProps = useMemo(() => {
        return {
            mask: /^(.+)$/,
            transformToUnmasked: (value: string) => value,
        };
    }, []);

    return useCustomMask(urlMaskProps);
};
